import Avatar from 'components/ui/avatar';
import Icon from 'components/ui/icon';

export const userProfileRegistry = {
  Avatar: ({user}) => <Avatar user={user} size='small' customClass='header__avatar' />,
  Name: ({ name }: { name: string }) => (
    <div className='header__name'>{name}</div>
  ),

  GearIcon: () => <Icon name='im-Settings' size={16} />,
};
